const gradingScales = {

    // headings
    createGradingScale: 'Create Grading Scale',
    editGradingScale: 'Edit Grading Scale',

    // List
    gradingScalesList: 'Grading Scales List',
    name: 'Grading Scale Name',
    programCodes: 'Program Codes',
    localGradingScale: 'Local Grading Scale',
    partnerCodes: 'Partner Codes',
    localGradeName: 'Local Grade Name',
    action: 'Action',

    // Form
    gradingScaleType: 'Grading Scale Type',
    programCode: 'Program Code',
    localGradingScale: 'Local Grading Scale',
    partnerCode: 'Partner Code',
    minimumGrade: 'Minimum Grade',
    maximumGrade: 'Maximum Grade',
    descGrade: 'Descriptive Grade',
    ectsGrade: 'ECTS Grade',
    grade: 'Grade',
    maxPercentage: 'Percentage (Max)',
    minPercentage: 'Percentage (Min)',


};

export default gradingScales;